import type { ReactNode } from "react"
import { cn } from "@/lib/cn"

// Small square icon container used inside metric cards + nav items.
// Two tones: gold (default — restraint accent) or red (urgent / brand).
type Props = {
  children: ReactNode
  tone?: "gold" | "red"
  className?: string
}

export function IconBadge({ children, tone = "gold", className }: Props) {
  return (
    <div
      className={cn(
        "flex h-10 w-10 items-center justify-center rounded-control border bg-white/5 text-lg",
        tone === "gold"
          ? "border-vip-gold/30 text-vip-goldSoft"
          : "border-brand-red/30 text-brand-red",
        className,
      )}
    >
      {children}
    </div>
  )
}
